import { Button } from "@material-ui/core";
import { FC } from "react";
import { Link } from "react-router-dom";

type Properties = {
  to: string;
  children: JSX.Element | JSX.Element[] | string | string[];
  className?: string;
};

const NavButton: FC<Properties> = ({ to, children, className }) => {
  return (
    <Button className={className} variant="contained" component={Link} to={to}>
      {children}
    </Button>
  );
};

export default NavButton;
